import { render } from "./StartView.vue?vue&type=template&id=e9191c3c&scoped=true"
import script from "./StartView.vue?vue&type=script&lang=js"
export * from "./StartView.vue?vue&type=script&lang=js"

import "./StartView.vue?vue&type=style&index=0&id=e9191c3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9191c3c"]])

export default __exports__